<!--
   Created by qing on 2020/9/19
   Des: 
-->
<template>
  <div>
    <van-action-sheet
      v-if="templateList.length"
      title="请选择打印模板"
      get-container="body"
      v-model="showPrint"
      :actions="templateList"
      cancel-text="取消"
      close-on-click-action
      @select="printClick">
    </van-action-sheet>

    <van-action-sheet
      v-else
      title="请选择打印模板"
      get-container="body"
      v-model="showPrint">
      <div style="height: 200px; display: flex; justify-content: center; align-items: center;">
        <span style="font-size: 14px;">暂无打印模板</span>
      </div>
    </van-action-sheet>

    <van-popup
      class="print-preview-popup"
      v-model="previewVisible"
      get-container="body"
      :style="{ height: '95%', width: '100%' }"
      position="bottom"
      @close="popupClose">
      <div class="print-preview-container">
        <div class="header">
          <div>
            打印预览
          </div>
          <div class="handle">
            <van-button
              v-if="!previewLoading && !previewError"
              type="default"
              @click="preview">
              预览
            </van-button>
            <van-button
              v-if="!previewLoading && !previewError"
              type="default"
              @click="download">
              打印
            </van-button>
            <van-icon name="cross" @click="close"/>
          </div>
        </div>
        <template v-if="!previewLoading">
          <div class="content" v-if="!previewError">
            <img v-for="(url, idx) in imageUrlList" :src="url" alt="" @click="onClickImage(idx)">
          </div>
          <div v-else style="display: flex; align-items: center; justify-content: center; width: 100%; height: 100%;">
            {{errorMsg}}
          </div>
        </template>
        <div v-if="previewLoading" class="print-loading-container">
          <van-loading type="spinner" color="#05A971" size="26px" style="margin-right: 10px;"/>
          <div class="title">正在为您生成打印文件</div>
        </div>
      </div>
    </van-popup>
    <van-popup
      class="print-preview-popup"
      v-model="previewWordVisible"
      get-container="body"
      :style="{ height: '95%', width: '100%' }"
      position="bottom"
      @close="popupClose">
      <div class="print-preview-container">
        <div class="header">
          <div>
            打印预览
          </div>
          <div class="handle">
            <van-button
              v-if="!loading && !errInfo"
              type="default"
              @click="download">
              打印
            </van-button>
            <van-icon name="cross" @click="close"/>
          </div>
        </div>
        <div v-if="!loading" style="width: 100%; height: calc(100% - 50px);;">

          <embed
            v-if="false"
            :src="printUrl"
            width="100%"
            height="100%"
            style="position: absolute"
            type="application/pdf">

          <iframe
            v-if="false"
            :src="printUrl"
            width="100%"
            height="100%"
            frameborder="0">
          </iframe>
          <div
            v-if="!errInfo"
            id="preViewPdf"
          ></div>

          <div v-if="errInfo" style="width: 100%; text-align: center; margin-top: 50px;">
            {{errInfo}}
          </div>

        </div>
        <div v-if="loading" class="print-loading-container">
          <van-loading type="spinner" color="#05A971" size="26px" style="margin-right: 10px;"/>
          <div class="title">正在为您生成打印文件</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import {ImagePreview} from 'vant'
  import {getBlob} from "../../assets/js/Untis";
  import Pdfh5 from "pdfh5"
  import "pdfh5/css/pdfh5.css"
  export default {
    props: {
      companyId: {
        type: String,
        default: ''
      },
      appId: {
        type: String,
        default: ''
      },
      formId: {
        type: String,
        default: ''
      },
      instanceId: {
        type: String,
        default: ''
      },
      scopeType: {
        type: String,
        default: 'ALL'
      },
      dataId: {
        type: String,
        default: ''
      },
      pushResultPage: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        showPrint: false,
        previewVisible: false,
        templateList: [],
        taskId: '',
        downloadUrl:'',
        imageUrlList: [],
        timer: null,
        previewLoading: true,
        previewError: false,
        errorMsg: '',
        printTimer: null,
        previewWordVisible: false,
        printUrl: '',
        loading: false,
        errInfo: '',
        pdfh5: null
      }
    },
    components: {},
    created() {
    },
    methods: {
      open(scopeType) {
        this.templateList = []
        const toast = this.$toast.loading({message: '加载中...'})
        this.$store.dispatch('actionPrintTempList', {
          companyId: this.companyId,
          appId: this.appId,
          formId: this.formId,
          dataId: scopeType || this.dataId,
          scopeType: scopeType || this.scopeType
        }).then(res => {
          if (res) {
            res.pdfTemplateList.forEach(item => {
              this.templateList.push({
                type: 'PDF',
                id: item.recordId,
                name: item.templateName,
                color: '#4A66FA'
              })
            })
            res.uploadList.forEach(item => {
              this.templateList.push({
                type: 'EXCEL',
                name: item.templateName,
                color: '#333333',
                id: item.itemId
              })
            })
            res.wordTemplateList.forEach(item => {
              this.templateList.push({
                type: 'WORD',
                id: item.templateId,
                name: item.templateName,
                color: '#2d8cf0',
              })
            })
          }
          this.showPrint = true
        }).catch(console.error)
          .finally(() => {
            toast.clear()
          })
      },

      // 打印
      printClick(info) {
        const toast = this.$toast.loading({message: '打印中...'})
        if (info.type === 'PDF') {
          this.$store.dispatch('actionPrintPdfResultGet', {
            companyId: this.companyId,
            appId: this.appId,
            formId: this.formId,
            templateId: info.id,
            instanceId: this.instanceId,
            needType: ["IMAGE", "PDF"]
          }).then(res => {
            this.taskId = res.taskId
            this.previewVisible = true
            this.pollResult()
          }).catch(console.error)
        } else if (info.type === 'WORD') {

          this.$store.dispatch('actionFormDataBatchWordPrint', {
            appId: this.appId,
            formId: this.formId,
            templateId: info.id,
            instanceIdList: [this.instanceId]
          }).then(res => {
            this.errInfo = ''
            this.previewWordVisible = true
            this.pollWordRes(res.taskId)
          }).catch(console.error)
        } else {
          this.$store.dispatch('actionFormLinkPrintTemp', {
            companyId: this.companyId,
            appId: this.appId,
            formId: this.formId,
            itemId: info.id,
            instanceId: this.instanceId
          }).then(res => {
            if (this.pushResultPage) {
              return this.$store.dispatch('actionNodeSave', {
                companyId: res.companyId,
                exportId: res.exportId,
                type: 'PRINT_RESULT',
                pageTitle: info.name
              }).then(res => {
                this.$router.push({
                  name: 'printResult',
                  query: {
                    key: res.nodeKey
                  }
                })
              })
            } else {
              this.showPrint = false
              this.$emit('selectTempComplete', {
                companyId: res.companyId,
                exportId: res.exportId,
                type: 'PRINT_RESULT',
                pageTitle: info.name
              })
            }

          })
            .catch(console.error)
            .finally(() => {
              toast.clear()
            })
        }
      },

      pollResult() {
        this.previewLoading = true
        this.$store.dispatch('actionApprovalCommentSignResult', {
          taskId: this.taskId
        }).then(res => {
          if (res.executeFinish === 0) {
            this.timer = setTimeout(() => {
              this.pollResult()
            }, 1000)
          } else if (res.executeFinish === 1) {
            this.downloadUrl = res.resultInfo.downloadUrl
            this.imageUrlList = res.resultInfo.imageUrlList
            this.previewLoading = false
          } else if (res.executeFinish === -1) {
            this.errorMsg = res.errorMsg
            this.previewError = true
            this.previewLoading = false
          }
        }).catch(console.error)
      },

      pollWordRes(taskId) {
        console.log('pollPrintResult', taskId)
        this.clearPrintTimer()
        this.loading = true
        this.$store.dispatch('actionPrintTaskPoll', {
          taskId
        }).then(res => {
          if (['WAITING', 'RUNNING'].includes(res.status)) {
            this.printTimer = setTimeout(() => {
              this.pollWordRes(taskId)
            }, 2000)
          } else {
            this.clearPrintTimer()
            if (res.status === 'FINISH' && res.downLoadUrl) {
              if (this.previewWordVisible) {
                this.printUrl = res.downLoadUrl
                this.downloadUrl = res.downLoadUrl
                this.loading = false
                setTimeout(() => {
                  this.pdfh5 = new Pdfh5("#preViewPdf", {
                    pdfurl: res.downLoadUrl
                  });
                },1000)
                // getBlob(res.downLoadUrl, blob => {
                //   const uri = URL.createObjectURL(blob)
                //   this.printUrl = uri
                //   this.loading = false
                // })
              }
            } else if (res.status === 'ERROR') {
              this.errInfo = res.errorMsg || '打印失败'
            }
          }
        }).catch(console.error)
      },
      clearPrintTimer() {
        if (this.printTimer) {
          clearTimeout(this.printTimer)
          this.printTimer = null
        }
        if (this.pdfh5) {
          this.pdfh5.destroy()
        }
      },
      close() {
        this.previewVisible = false
        this.previewWordVisible = false
        this.clearPrintTimer()
      },
      download() {
        if (window.isWexin || window.isWxWork || window.isLark) {
          this.$store.dispatch('reqNodeSave', {
            fileType: 'pdf',
            fileUrl: this.downloadUrl,
            fileName: '',
            pageType: 'PRINT'
          }).then(res => {
            this.$router.push({
              name: 'attDownload',
              query: {
                key: res.nodeKey
              }
            })
          }).catch(console.error)

        } else {
          if (!this.downloadEle) {
            this.downloadEle = document.createElement('a')
            this.downloadEle.setAttribute('target', '_blank')
          }
          this.downloadEle.setAttribute('href', this.downloadUrl)
          this.downloadEle.click()
        }
      },
      preview() {
        ImagePreview({
          images: this.imageUrlList,
          startPosition: 0
        })
      },
      onClickImage(idx) {
        ImagePreview({
          images: this.imageUrlList,
          startPosition: idx
        })
      },
      popupClose() {
        if (this.timer) {
          clearTimeout(this.timer)
          this.timer = null
        }
        this.clearPrintTimer()
      },
    }
  }
</script>

<style lang="less">

  .print-preview-popup {

    .print-preview-container {
      height: 100%;
      background: #f3f3f3;

      .header {
        background: #ffffff;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 20px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);

        .handle {
          display: flex;
          align-items: center;

          .van-button {
            height: 30px;
            margin-right: 10px;
          }

        }

      }

      .content {
        height: calc(100% - 50px);
        width: 100%;
        overflow: auto;

        img {
          width: 100%;
          height: auto;
          margin: 10px;
        }
      }

      .print-loading-container {
        height: calc(100% - 50px);
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .van-loading {
          margin-bottom: 20px;
        }

        .title {
          color: #05A971;
        }
      }
    }
  }
</style>